import React from "react";
import { Card, Chip, Typography } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import Div from "@jumbo/shared/Div";
import moment from "moment";

const Item = ({ children, sx }) => (
  <Div sx={{ p: (theme) => theme.spacing(1, 2), ...sx }}>{children}</Div>
);

const LogsDownloadsRPIsCards = ({ log }) => {
  return (
    <Card sx={{ my: 1 }}>
      <Stack direction={"row"} alignItems={"center"} sx={{ p: 2 }}>
        <Item
          sx={{
            flexBasis: "17%",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            {log.number}
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Revista Nº
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "35%",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            Detalhes
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            {log.message}
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "12%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            <Chip
              label={String(log.status).toUpperCase()}
              color={log.status === "sucesso" ? "success" : "error"}
            />
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            Status
          </Typography>
        </Item>
        <Item
          sx={{
            flexBasis: "20%",
            marginRight: "auto",
          }}
        >
          <Typography variant={"h6"} mb={0.5}>
            Data
          </Typography>
          <Typography variant={"body1"} color="text.secondary">
            {moment(log.date).format("HH:MM:ss [de] DD/MM/YYYY")}
          </Typography>
        </Item>
      </Stack>
    </Card>
  );
};

export default LogsDownloadsRPIsCards;
